import type { ParsedSymbol } from '@/features/chart/lib/configs/options-config'
import { resolveOptionSymbol } from '@/features/chart/lib/utils/option-util'
import { toExchangeString } from '@/lib/proto/util'
import type { LinkingTickerInfo } from '@/state/linking'
import type { OptionChainOverride } from '@/state/linking-group'
import type { Exchange, Instrument } from '@/types/generated/common/types'

export function buildOptionChainOverride({
  activeOptionTicker,
  cardId,
  exchange,
  instruments,
  optionSymbolMap,
  selectedTicker,
}: {
  activeOptionTicker: string | null
  cardId: string
  exchange: Exchange
  instruments: Instrument[]
  optionSymbolMap: Map<string, ParsedSymbol>
  selectedTicker: LinkingTickerInfo | null
}): OptionChainOverride | null {
  if (selectedTicker?.type !== 'options') return null
  const parsed = resolveOptionSymbol(selectedTicker.symbol, optionSymbolMap)
  if (!parsed || parsed.ticker !== activeOptionTicker) return null
  const selectedInstrument = instruments.find(
    (instrument) => instrument.symbol === selectedTicker.symbol && instrument.exchange === exchange
  )

  return {
    sourceCardId: cardId,
    symbol: selectedTicker.symbol,
    type: 'options',
    exchange: toExchangeString(exchange),
    baseCurrency: selectedTicker.baseCurrency,
    expiry: selectedTicker.expiry,
    pricePrecision: selectedInstrument?.pricePrecision,
    strikePrice: String(parsed.strike),
    optionType: parsed.type === 'C' ? 'call' : 'put',
  }
}
